'use client'

import { INTENT_SAME_AS_WEB, type WebViewIntent } from './react-native.intent'
import { __unsafe__client__isInReactNativeWebViewRuntime } from './react-native.runtime.client'

export default async function handleIntent(
  intent: WebViewIntent | undefined,
  runtime: {
    whenInBrowser?: () => Promise<void> | void
    whenInWebView?: () => Promise<void> | void
    onBeforeSendIntentInWebView?: () => Promise<void> | void
    onUndefinedIntentInWebView?: () => Promise<void> | void
  } = {},
): Promise<void> {
  const isInWebView = __unsafe__client__isInReactNativeWebViewRuntime()

  if (!isInWebView) {
    await runtime.whenInBrowser?.()
  } else {
    await runtime.whenInWebView?.()

    if (intent) {
      if (intent.name === INTENT_SAME_AS_WEB.name) {
        return await runtime.whenInBrowser?.()
      }

      await runtime.onBeforeSendIntentInWebView?.()

      return window.ReactNativeWebView.postMessage(JSON.stringify(intent))
    } else {
      alert('TODO')

      await runtime.onUndefinedIntentInWebView?.()
    }
  }
}